import { render, staticRenderFns } from "./StaffEditPreferences.vue?vue&type=template&id=402cf977&scoped=true&"
import script from "./StaffEditPreferences.vue?vue&type=script&lang=js&"
export * from "./StaffEditPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402cf977",
  null
  
)

export default component.exports